module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app-content"
  }, [_c('div', {
    staticClass: "app-content-body leiloes"
  }, [_c('CHeader'), _vm._v(" "), _c('router-view')], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8a915a40","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/website/leiloeiro/Main.vue
// module id = 1793
// module chunks = 17